import { getAccessToken } from "../../utils/auth";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import axios from "../../utils/api.js";

const SaveDaranalysisForm = () => {
  const [formData, setFormData] = useState({
    questionNumber: "",
    question: "",
    answerType: "text",
    options: [],
  });

  const [option, setOption] = useState("");
  const [weightage, setWeightage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleOptionChange = (e) => {
    setOption(e.target.value);
  };

  const handleWeightageChange = (e) => {
    setWeightage(e.target.value);
  };

  const addOption = () => {
    if (option) {
      setFormData((prev) => ({
        ...prev,
        options: [
          ...prev.options,
          { option, weightage: weightage ? Number(weightage) : undefined },
        ],
      }));
      setOption("");
      setWeightage("");
      setError("");
    } else {
      setError("Option text is required");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const { questionNumber, question, answerType, options } = formData;
    if (!questionNumber || !question || !answerType) {
      setError("Missing required fields");
      return;
    }

    if (answerType === "multiple-choice" && options.length === 0) {
      setError("Options are required for multiple-choice questions");
      return;
    }

    const token = getAccessToken();
    if (!token) {
      setError("No token found. Please log in first.");
      return;
    }

    try {
      const response = await axios.post("/daranalysisQuestions", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      alert(response.data.message);
      setFormData({
        questionNumber: "",
        question: "",
        answerType: "text",
        options: [],
      });
    } catch (err) {
      setError(err.response?.data?.message || "Server error");
    }
  };

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "0.6rem 0.75rem",
    fontSize: "1rem",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    outline: "none",
  };

  const labelStyle = {
    display: "block",
    marginBottom: 6,
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#64748b",
  };

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        background:
          "radial-gradient(1200px 600px at 10% 0%, rgba(37, 99, 235, 0.10), rgba(255,255,255,0) 60%), radial-gradient(900px 450px at 90% 15%, rgba(16, 185, 129, 0.10), rgba(255,255,255,0) 55%), #ffffff",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        padding: "20px 32px 48px",
        boxSizing: "border-box",
      }}
    >
      <IconButton
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          color: "#4a4a4a",
          zIndex: 10,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <div style={{ textAlign: "center", marginTop: 20, marginBottom: 28 }}>
        <h1
          style={{
            margin: 0,
            marginBottom: 8,
            fontSize: "1.85rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Save Daranalysis Questions
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: "0.95rem",
            color: "#64748b",
            fontWeight: 400,
          }}
        >
          Add questions and answer types for DAR analysis
        </p>
      </div>

      <div style={{ maxWidth: 560, margin: "0 auto" }}>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Question Number</label>
            <input
              type="number"
              name="questionNumber"
              value={formData.questionNumber}
              onChange={handleChange}
              required
              min="0"
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Question</label>
            <input
              type="text"
              name="question"
              value={formData.question}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={labelStyle}>Answer Type</label>
            <select
              name="answerType"
              value={formData.answerType}
              onChange={handleChange}
              required
              style={{
                ...inputStyle,
                cursor: "pointer",
                appearance: "none",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%2364748b' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 0.75rem center",
                backgroundSize: "1.25rem",
                paddingRight: 40,
              }}
            >
              <option value="text">Text</option>
              <option value="multiple-choice">Multiple Choice</option>
            </select>
          </div>

          {formData.answerType === "multiple-choice" && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ display: "flex", gap: 12, alignItems: "flex-end", flexWrap: "wrap" }}>
                <div style={{ flex: "1 1 200px" }}>
                  <label style={labelStyle}>Add Option</label>
                  <input
                    type="text"
                    value={option}
                    onChange={handleOptionChange}
                    placeholder="Enter option text"
                    style={inputStyle}
                  />
                </div>
                <div style={{ width: 100 }}>
                  <label style={labelStyle}>Weightage</label>
                  <input
                    type="number"
                    value={weightage}
                    onChange={handleWeightageChange}
                    min="0"
                    placeholder="Optional"
                    style={inputStyle}
                  />
                </div>
                <button
                  type="button"
                  onClick={addOption}
                  style={{
                    padding: "0.6rem 1rem",
                    fontSize: 14,
                    fontWeight: 600,
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  Add Option
                </button>
              </div>
              {formData.options.length > 0 && (
                <ul style={{ marginTop: 12, paddingLeft: 20, marginBottom: 0, fontSize: 14, color: "#64748b" }}>
                  {formData.options.map((opt, index) => (
                    <li key={index} style={{ marginBottom: 4 }}>
                      {opt.option} {opt.weightage != null ? `(Weightage: ${opt.weightage})` : "(N/A)"}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

          {error && (
            <div style={{ color: "#dc2626", marginBottom: 12, fontSize: 14 }}>{error}</div>
          )}

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "0.75rem 1rem",
              fontSize: "1rem",
              fontWeight: 600,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
            }}
          >
            Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default SaveDaranalysisForm;
